import * as THREE from "three";
import {
	shareForProcessLifetime,
	UNIT_BOX,
	UNIT_CYLINDER,
} from "../../engines/geometry";

/** Shared sphere for guide door handles — disposal is a no-op by design. */
export const GUIDE_SPHERE = shareForProcessLifetime(
	new THREE.SphereGeometry(1, 8, 8),
);

/** Set of shared singleton geometries that must never be disposed. */
export const SHARED_GEOMETRIES = new Set<THREE.BufferGeometry>([
	UNIT_BOX,
	UNIT_CYLINDER,
	GUIDE_SPHERE,
]);

export function disposeGroupGeometries(obj: THREE.Object3D): void {
	obj.traverse((child) => {
		if (
			child instanceof THREE.Mesh &&
			child.geometry &&
			!SHARED_GEOMETRIES.has(child.geometry)
		) {
			child.geometry.dispose();
		}
		if (child instanceof THREE.Sprite) {
			child.material.dispose();
		}
		if (
			child instanceof THREE.Mesh &&
			(child.userData?.interactionKind || child.userData?.measurementTarget) &&
			child.material instanceof THREE.Material
		) {
			child.material.dispose();
		}
	});
}

export function disposeInteractionGroup(group: THREE.Object3D): void {
	group.traverse((child) => {
		if (
			child instanceof THREE.Mesh &&
			child.geometry &&
			!SHARED_GEOMETRIES.has(child.geometry)
		) {
			child.geometry.dispose();
		}
		if (
			child instanceof THREE.Mesh &&
			child.material instanceof THREE.Material
		) {
			child.material.dispose();
		}
	});
}
